import React, { useEffect, useState } from "react";
import settingScheduleService from "../../../services/settingSchedule.service";

const CountCourse = (props: any) => {
  const { schedule, curri } = props;
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(false);
  // const [course, setCourse] = useState([]);
  // const [sendList, setSendList] = useState([]);

  useEffect(() => {
    (async () => {
      settingScheduleService.countCourse(schedule).then((res) => {
        if (res.data.length > 0) {
          setCount(
            res.data.filter((x: any) => x.course.owner.id === curri.id).length
          );
          setShow(true);
        } else {
          setCount(0);
          setShow(true);
        }
      });
    })();
  }, []);

  if (show) return <>{`${count}`}</>;
  return <></>;
};

export default CountCourse;
